







































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { getCurrentTime } from "@/utils/base";
import { GetWendaDetail, EditQA } from "@/request/common";
@Component({})
export default class Name extends Vue {
  @Prop()
  private data: any;
  @Prop({
    type: Boolean,
    default: false,
  })
  private showReply: any; // 是否显示回复输入框
  @Prop()
  private IfShow: any;
  @Watch("IfShow", { immediate: true })
  private IfShowChange() {
    this.ifVisible = this.IfShow;
    if (this.IfShow) {
      this.getDetail();
    }
  }
  private ifVisible: any = false;
  private detail: any = {};
  private get user() {
    return this.$store.state.user;
  }
  private cancel() {
    this.$emit("cancel");
  }
  private preview(url: any) {
    window.open(url);
  }
  private getDetail() {
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    const params: any = {
      params: {
        wenda_id: this.data.wenda_id,
      },
    };
    GetWendaDetail(this, params, loading)
      .then((res: any) => {
        loading.close();
        this.detail = res;
      })
      .catch(() => {
        loading.close();
      });
  }
  private replySure() {
    if (!this.detail.reply_content) {
      this.$message.warning("请输入回复内容");
      return;
    }
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    this.detail.asker_id = this.detail.asker_id;
    this.detail.banji_id = this.detail.banji_id;
    this.detail.reply_id = this.user.user_id;
    this.detail.reply_time = getCurrentTime("yyyy-MM-dd HH:mm:ss");
    EditQA(this, this.detail, loading)
      .then((res: any) => {
        loading.close();
        this.$message.success("回复成功");
        this.$emit("replySure");
      })
      .catch(() => {
        loading.close();
      });
  }
}
